import { render, staticRenderFns } from "./RequestCardClosed.vue?vue&type=template&id=15c6323c&scoped=true&"
import script from "./RequestCardClosed.vue?vue&type=script&lang=js&"
export * from "./RequestCardClosed.vue?vue&type=script&lang=js&"
import style0 from "./RequestCardClosed.vue?vue&type=style&index=0&id=15c6323c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6323c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c6323c')) {
      api.createRecord('15c6323c', component.options)
    } else {
      api.reload('15c6323c', component.options)
    }
    module.hot.accept("./RequestCardClosed.vue?vue&type=template&id=15c6323c&scoped=true&", function () {
      api.rerender('15c6323c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/quotation-requests/parts/RequestCardClosed.vue"
export default component.exports